var render = function render(_c,_vm){return _c('button',{staticClass:"btn flx_ctr",attrs:{"disabled":_vm.props.text === '',"aria-label":_vm.props.ariaLabel},on:{"click":_vm.props.func}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }